module.exports = __webpack_public_path__ + "img/vegas2.defa99f6.jpg";